<form class="grid gap-6 mb-5" [formGroup]="form">
  <div class="headline" i18n="@@createFiscal_step2_accounting-type">Accounting type</div>
  <xena-radio-group formControlName="providerId">
    <xena-radio *ngFor="let provider of providers" [value]="provider.fiscalSetupId" class="mb-4">
      <div>{{ provider.onboardingTypeNameTranslated }}</div>
      <small class="text-muted">{{ provider.onboardingTypeDescriptionTranslated }}</small>
    </xena-radio>
  </xena-radio-group>
  <div class="grid grid-cols-2 gap-6">
    <xena-select formControlName="currencyAbbreviation" label="Main currency" i18n-label="@@createFiscal_step2_mainCurrency" hoist>
      <xena-menu-item *ngFor="let c of currencies" [value]="c.iSOCurrencySymbol">{{ c.currencyDisplayName }}</xena-menu-item>
    </xena-select>
    <xena-select formControlName="culture" label="Language" i18n-label="@@createFiscal_step2_language" hoist>
      <xena-menu-item *ngFor="let c of cultures" [value]="c.culture">{{ c.name }}</xena-menu-item>
    </xena-select>
  </div>
</form>
